//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ArticlePreviewBlock',
  props: {
    article: {
      type: Object,
      required: true
    },
    headingLines: {
      type: Number,
      default: 3
    },
    lines: {
      type: Number,
      default: 2
    },
    showImage: {
      type: Boolean,
      default: true
    },
    shortAbstract: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadedImg: false,
      brokenImg: false
    }
  },
  computed: {
    location() {
      const location = this.article.country != null ? this.article.country.name : this.article.region?.name
      return location?.toUpperCase()
    }
  },
  methods: {
    navigate() {
      if (this.article.redirectUrl) window.location.href = this.article.redirectUrl
      else {
        this.$router.push({
          path: `/${this.getContentTypeUrlName(this.article.contentType)}/${this.article.slug}--${
            this.article.externalId
          }`
        })
      }
    }
  }
}
